var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrowButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 26,
    height: 26,
    rx: 3,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 12.5044H9L12.29 9.21203C12.3837 9.119 12.4581 9.00832 12.5089 8.88637C12.5597 8.76442 12.5858 8.63362 12.5858 8.50151C12.5858 8.36941 12.5597 8.23861 12.5089 8.11666C12.4581 7.99471 12.3837 7.88403 12.29 7.791C12.1026 7.60462 11.8492 7.5 11.585 7.5C11.3208 7.5 11.0674 7.60462 10.88 7.791L6.59 12.0941C6.21441 12.4677 6.00223 12.9752 6 13.5051C6.00487 14.0316 6.21684 14.535 6.59 14.9061L10.88 19.2092C10.9732 19.3019 11.0838 19.3752 11.2054 19.4251C11.3269 19.475 11.4571 19.5005 11.5885 19.5C11.7199 19.4995 11.8499 19.4732 11.9712 19.4224C12.0924 19.3717 12.2024 19.2975 12.295 19.2042C12.3876 19.1109 12.4609 19.0003 12.5107 18.8786C12.5606 18.757 12.586 18.6267 12.5856 18.4952C12.5851 18.3637 12.5588 18.2336 12.508 18.1123C12.4573 17.991 12.3832 17.8809 12.29 17.7882L9 14.5058H19C19.2652 14.5058 19.5196 14.4004 19.7071 14.2127C19.8946 14.0251 20 13.7705 20 13.5051C20 13.2397 19.8946 12.9852 19.7071 12.7975C19.5196 12.6098 19.2652 12.5044 19 12.5044Z",
    fill: "#030304"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowButton);
export default __webpack_public_path__ + "static/media/back-arrow-button.c1dd257520b4dd161e4b23693fa2d6dd.svg";
export { ForwardRef as ReactComponent };